/* RESPONSIBLE TEAM: team-knowledge-foundations */

export enum CategoryTypes {
  Necessary = 'necessary',
  Functional = 'functional',
  Advertisement = 'advertisement',
  Performance = 'performance',
}
